<template>
  <div style="height: 100%;">
    <!--  ==================系统配置---流程定义列表===============  -->
    <a-card v-if="!xmlFrame.open||xmlView">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">

            <a-col :md="6" :sm="12">
              <a-form-item :label="$t('流程名称')">
                <a-input :placeholder="$t('请输入流程名称查询')" v-model="queryParam.name"></a-input>
              </a-form-item>
            </a-col>
            <!-- <a-col :md="6" :sm="12">
              <a-form-item label="流程分类">
                <a-select v-model="queryParam.category" style="width: 100%">
                  <a-select-option v-for="item in categorys" :key="item.id" :value="item.id" :label="item.itemText">
                    {{item.itemText}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col> -->
            <a-col :md="6" :sm="12">
              <a-form-item :label="$t('状态')">
                <!-- <a-switch size="default" v-model="queryParam.active" @change="handleQuery" /> -->
                <a-select v-model="queryParam.active" style="width: 100%">
                  <a-select-option :value="1">{{ $t('激活') }}</a-select-option>
                  <a-select-option :value="0">{{ $t('挂起') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="toggleSearchStatus">

            </template>
            <a-col :md="6" :sm="8">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                        {{ toggleSearchStatus ? '收起' : '展开' }}
                        <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                      </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <a-button v-has="'process:add'" type="primary" icon="plus" @click="handleLoadXml">{{ $t('新增流程定义') }}</a-button>
        <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1">
              <a-icon type="delete" @click="batchDel" />
              删除
            </a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px">
            批量操作
            <a-icon type="down" />
          </a-button>
        </a-dropdown> -->
      </div>
      <!-- table区域-begin -->
      <div class="alter-info">

        <a-table ref="table" size="middle" :bordered="false" rowKey="id" :columns="columns" :dataSource="dataSource" :pagination="ipagination" :loading="loading"
           :scroll="{ x: 'max-content' }" @change="handleTableChange">

          <!-- 字符串超长截取省略号显示-->
          <span slot="templateContent" slot-scope="text">
            <j-ellipsis :value="text" :length="25" />
          </span>
          <!-- 流程分类 -->
          <span slot="categorySlot" slot-scope="text">
            <span>{{ getCategoryName(text) }}</span>
          </span>
          <span slot="nameSlot" slot-scope="text,record">
            <a-button @click="handleReadImage(record.deploymentId)">{{text }}</a-button>
          </span>
          <span slot="versionSlot" slot-scope="text,record">
            <a-tag color="cyan">v{{ text }}</a-tag>
          </span>
          <span slot="suspensionStateSlot" slot-scope="text,record">
            <a-tag color="#87d068" v-if="text === 1">{{ $t('激活') }}</a-tag>
            <a-tag color="#f50" v-if="text=== 2">{{ $t('挂起') }}</a-tag>
          </span>

          <span slot="action" slot-scope="text, record">
            <a v-has="'process:edit'" @click="handleLoadXml(record)">{{ $t('编辑') }}</a>

            <a-divider type="vertical" />

            <a-dropdown>
              <a class="ant-dropdown-link">{{ $t('更多') }}
                <a-icon type="down" /></a>
              <a-menu slot="overlay">
                <a-menu-item v-if="record.suspensionState === 1">
                  <a-popconfirm :title="$t('确定挂起吗?')" @confirm="() => handleUpdateSuspensionState(record)">
                    <a>{{ $t('挂起') }}</a>
                  </a-popconfirm>
                </a-menu-item>
                <a-menu-item v-if="record.suspensionState === 2">
                  <a-popconfirm :title="$t('确定激活吗?')" @confirm="() => handleUpdateSuspensionState(record)">
                    <a>{{ $t('激活') }}</a>
                  </a-popconfirm>
                </a-menu-item>
                <a-menu-item v-has="'process:delete'">
                  <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record)">
                    <a>{{ $t('删除') }}</a>
                  </a-popconfirm>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </span>
        </a-table>
      </div>
    </a-card>
    <!-- 流程图 -->
    <a-card v-if="xmlFrame.open&&!xmlView" :title="xmlFrame.title">
      <a slot="extra" href="#" @click="()=>{xmlFrame.open=false}">{{ $t('返回') }}</a>
      <bpmn-modeler v-if="xmlShow" ref="refNode" :xml="xmlData" :users="users" :groups="groups" :categorys="categorys" :is-view="xmlView" @save="save" />
      <!-- <bpmn-modeler v-if="xmlShow" ref="refNode" :xml="xmlData" :users="users" :groups="groups" :categories="categorys" :is-view="xmlView" @save="save" /> -->
    </a-card>
    <!--  弹窗预览  -->
    <a-modal :title="xmlFrame.title" :visible.sync="xmlView&&xmlFrame.open" :width="xmlFrame.width" :footer="null" closable
      @cancel="()=>{xmlView=false,xmlFrame.open=false}">
      <bpmn-modeler v-if="xmlShow" ref="refNode" :xml="xmlData" :users="users" :groups="groups" :categorys="categorys" :is-view="xmlView" @save="save" />
    </a-modal>

  </div>
</template>

<script>
import bpmnModeler from "workflow-bpmn-modeler";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import {
  categoryList,
  delDeployment,
  listDefinition,
  readXml,
  roleList,
  saveXml,
  updateState,
  userList
} from "@views/flowable/api/definition";

export default {
  components: {
    bpmnModeler,
  },
  mixins: [JeecgListMixin],
  data() {
    return {
      /*===================设计器属性======================*/
      users: [],
      groups: [],
      categorys: [],
      /*=================页面属性===================*/
      loading: true,
      allDefinitionList: [],
      xmlFrame: {
        width: '100%',
        title: this.$t('流程图'),
        open: false,
        src: "",
        height: '1000px'
      },
      // xml
      xmlData: "",
      xmlShow: true,
      xmlView: false,
      disableMixinCreated: true,
      queryParam:{
        active: 1
      }
    };
  },
  created() {
    this.initUserAndRole();
    this.loadData(1);
  },
  methods: {
    searchReset(){
      this.queryParam = {
        active:1
      };
      this.loadData();
    },
    /*===============设计器===============*/
    initUserAndRole() {
      userList({}).then(res => {
        this.users = res.result || []
        this.users.map(o => {
          o.id = o.username
          o.name = o.realname
        })
      })
      roleList({}).then(res => {
        this.groups = res.result || []
        this.groups.map(o => {
          o.name = o.roleName
        })
      })
      categoryList({ dictId: "1658010206426996738" }).then(res => {
        let Array = res.result.records || []
        for (let i = 0; i < Array.length; i++) {
          Array[i].name = Array[i].itemText;
        }
        console.log("的运动手表的", Array);
        this.categorys = Array
      })
    },
    getModelDetail(deployId) {
      // 发送请求，获取xml
      readXml(deployId).then(res => {
        this.xmlData = res.result;
      })
    },
    getCategoryName(category) {
      let find = this.categorys.find(o => o.id == category);
      if (find) {
        return find.name
      }
      return ''
    },
    /*保存流程定义*/
    save(data) {
      console.log(data);  // { process: {...}, xml: '...', svg: '...' }
      const params = {
        name: data.process.name,
        category: data.process.category,
        xml: data.xml
      }
      saveXml(params).then(res => {
        this.$message.success(res.message)
        // 关闭当前标签页并返回上个页面
        this.loadData()
        this.xmlFrame.open = false
      })
    },
    /*================页面===============*/
    handleQuery() {
      this.loadData(1);
    },
    /** 查询流程定义列表 */
    loadData(arg) {
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      this.loading = true;

      var param1 = this.getQueryParams();//查询条件
      param1.isLastVersion = 1;// 最新版本
      param1.suspensionState = this.queryParam.active;
      listDefinition(param1).then(res => {
        this.dataSource = res.result.records;
        if (res.result.total) {
          this.ipagination.total = res.result.total;
        } else {
          this.ipagination.total = 0;
        }
        this.loading = false;
        for (const definition of this.dataSource) {
          definition.hasChildren = true
        }
      });
      // 所有
      const param2 = Object.assign({
        isLastVersion: 0
      }, this.queryParam, {
        pageSize: 9999,
        pageNo: 1
      })
      listDefinition(param2).then(response => {
        console.log(response)
        this.allDefinitionList = response.result.records;
      });
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    /** 打开流程设计弹窗页面 */
    handleLoadXml(row) {
      if (row && row.deploymentId) {
        console.log(row.deploymentId)
        this.handleReadImage(row.deploymentId)
        this.xmlView = false
        this.xmlFrame.title = this.$t("编辑流程图");
      } else {
        //新增
        this.xmlData = ''
        this.xmlView = false
        this.xmlFrame.open = true
        this.xmlFrame.title = this.$t('新增流程')
        this.xmlShow = false
        this.$nextTick(() => {
          this.xmlShow = true
        })
      }
      this.xmlFrame.width = '90%'
    },
    /** 流程图查看 */
    handleReadImage(deploymentId) {
      this.xmlFrame.title = this.$t("流程图");
      this.xmlFrame.open = true;
      this.xmlFrame.width = '70%';
      // 发送请求，获取xml
      this.xmlView = true
      readXml(deploymentId).then(res => {
        if (res.success) {
          this.xmlData = res.result
        } else {
          this.$message.error(this.$t("获取流程图失败！"))
        }
      })
    },
    // 打开业务表单
    handleForm() {
    },
    // 配置业务表单
    handleAddForm(row) {
    },
    /** 挂起/激活流程 */
    handleUpdateSuspensionState(row) {
      let state = 1;
      if (row.suspensionState === 1) {
        state = 2
      }
      const params = {
        deployId: row.deploymentId,
        state: state
      }
      updateState(params).then(res => {
        this.$message.success(res.message);
        this.loadData();
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const params = {
        deployId: row.deploymentId
      }
      this.$confirm({
        title: this.$t("警告"),
        content: this.$t('是否确认删除流程定义编号为"{deployId}"的数据项?', { deployId: params.deployId }),
        confirmButtonText: this.$t("确定"),
        cancelButtonText: this.$t("取消"),
        type: "warning",
        onOk: () => {
          delDeployment(params).then(res => {
            this.loadData();
            if (res.success) {
              this.$message.success(this.$t('删除成功'));
            } else {
              this.$message.success(this.$t('删除失败'));
            }
          })
        }
      })
    },
    load(tree, treeNode, resolve) {
      const key = tree.key;
      const childrens = []
      for (const one of this.allDefinitionList) {
        if (one.key == key && one.id != tree.id) {
          childrens.push(one)
        }
      }
      console.log(tree, treeNode, this.allDefinitionList, childrens)
      resolve(childrens)
    }
  },
  computed: {
    getContainer() {
      return document.querySelector('#app')
    },
    columns() {
      return [
        {
        title: this.$t('序号'),
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: "center",
        fixed: 'left',
        customRender: (t, r, index) => {
        return parseInt(index) + 1;
        }
        },
        // {
        //   title: '流程定义id',
        //   align: "center",
        //   dataIndex: 'id',
        // },
        // {
        //   title: '流程定义key',
        //   align: "center",
        //   dataIndex: 'key',
        // },
        // {
        //   title: '流程分类',
        //   align: "center",
        //   dataIndex: 'category',
        //   scopedSlots: { customRender: 'categorySlot' },
        // },
        {
          title: this.$t('流程名称'),
          align: "center",
          dataIndex: 'name',
          scopedSlots: { customRender: 'nameSlot' },
        },
        // {
        //   title: '版本号',
        //   align: "center",
        //   dataIndex: 'version',
        //   scopedSlots: { customRender: 'versionSlot' },
        // },
        {
          title: this.$t('状态'),
          align: "center",
          dataIndex: 'suspensionState',
          scopedSlots: { customRender: 'suspensionStateSlot' },
        },
        {
          title: this.$t('部署时间'),
          align: "center",
          dataIndex: 'deploymentTime',
        },
        {
          title: this.$t('部署人'),
          align: "center",
          dataIndex: 'deploymentId',
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align: "center",
          fixed: 'right',
          width: 120,
          scopedSlots: { customRender: 'action' },
        }
      ]
    }
  }
};
</script>
<style scoped>
/deep/ .ant-card-body {
  height: 800px;
}

</style>